import script from "./Pathological.vue?vue&type=script&setup=true&lang=js"
export * from "./Pathological.vue?vue&type=script&setup=true&lang=js"

import "./Pathological.vue?vue&type=style&index=0&id=7ed4b5b9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed4b5b9"]])

export default __exports__